import InfoNotification from '../../InfoNotification';
import {ServerNotificationProps} from '../ServerNotification';
import {INotificationProps} from '@src/@interfaces/components/Notifications/INotificationProps';
import app from '@src/helpers/app';
import {toDate} from '@views/orders/fields/logs/messages';
import makeUrl from '@src/components/Notifications/server-notifications/makeUrl';
import getDashboardEndpoint from '@src/components/Notifications/server-notifications/Order/getDashboardEndpoint';

export default class DeadlineChanged extends InfoNotification<
        ServerNotificationProps<'App\\Notifications\\Order\\DeadlineChanged'> &
        INotificationProps
> {
    protected getWrapperTagProps(): any {
        const payload = this.props.notification.data;
        const namesResolver = app('names-resolver').clientRoutes;

        return {
            ...super.getWrapperTagProps(),
            to: makeUrl({
                uriItems: [
                    getDashboardEndpoint('manager-order-page', payload.orderId),
                    {
                        route: namesResolver.getShowRouteName('Orders'),
                        params: {id: String(payload.orderId)},
                    }
                ],
            }),
        };
    }

    protected getDescriptionReplacements() {
        const data = this.props.notification.data;

        return {
            ...data,
            was: toDate(data.was),
            became: toDate(data.became),
        };
    }
}
